import React, { useRef } from "react"
import { useDispatch } from "react-redux"
import { openConversation } from "reduxSlices/formSubmissionConversationsSlice"
import { useModal } from "hooks"
import Modal, { ModalHeader, DEFAULT_MODAL_STYLE } from "shared/Modal"
import ConversationForm from "./ConversationForm"
import OpenConversationButton from "./OpenConversationButton"

const MODAL_STYLE = {
  content: {
    ...DEFAULT_MODAL_STYLE.content,
    overflowX: "hidden",
    transform: "translate(calc(-50% - 1rem), -52%)",
  },
}

const OpenConversation = () => {
  const dispatch = useDispatch()

  const { modalIsOpen, openModal, closeModal } = useModal()
  const titleInputRef = useRef()

  const cancelOpeningConversation = () => {
    closeModal()
  }

  const createConversation = async (conversationData) => {
    try {
      await dispatch(openConversation({ conversationData })).unwrap()
      closeModal()
    } catch {
      // Error state handled by redux slice automatically when the thunk is rejected.
    }
  }

  return (
    <>
      <OpenConversationButton onClick={openModal} />
      <Modal isOpen={modalIsOpen} onAfterOpen={() => titleInputRef.current?.focus()} style={MODAL_STYLE}>
        <div className="flex flex-col">
          <ModalHeader closeModal={closeModal} heading="New Conversation" />
          <ConversationForm
            onCancel={cancelOpeningConversation}
            onSubmit={createConversation}
            ref={titleInputRef}
          />
        </div>
      </Modal>
    </>
  )
}

export default OpenConversation
